// extracted by mini-css-extract-plugin
export default {"root":"GridSelect-module-root-NRYeL","configTitle":"GridSelect-module-configTitle-rzOOr","error":"GridSelect-module-error-TpMVA","options":"GridSelect-module-options-NguOt"};